import React from 'react'

type SendProps = {
  width?: number,
  height?: number,
  color?: string
}

const Send = ({ height = 16, width = 17, color = "#2D88F3" }: SendProps) => {
  return (
    <svg
      className="drift-default-icon drift-default-icon--send"
      width={width}
      height={height}
      viewBox="0 0 17 16">
      <path
        fill={color}
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 1l2.166 5.39 8.5 1.564-8.5 1.666L1 15l16-7z"
      />
    </svg>
  )
}

export default Send
